import { combineReducers } from "redux"

import templateDetails from "./templateDetails"
import templates from "./templates"

import technologies from "./technologies"
import technologyDetails from "./technologyDetails"

import activities from "./activities"
import activityDetails from "./activityDetails"
import amountUnits from "./amountUnits"
import customers from "./customers"
import holidays from "./holidays"
import imports from "./imports"
import licenceModuleDetails from "./licenceModuleDetails"
import licenceExistence from "./licenceExistence"
import licenceModules from "./licenceModules"
import operations from "./operations"
import orderPositions from "./orderPositions"
import productionOrders from "./productionOrders"
import projectDetails from "./projectDetails"
import projects from "./projects"
import resourceDetails from "./resourceDetails"
import resources from "./resources"
import userList from "./userList"
import userDetails from "./userDetails"

import basedataResourceDetails from "./basedataResourceDetails"
import modules from "./modules"
import modulesUserManagement from "./modulesUserManagement"
import planningObjectsActivityDetails from "./planningObjectsActivityDetails"
import planningObjectsOperationDetails from "./planningObjectsOperationDetails"
import planningObjectsOrderPositionDetails from "./planningObjectsOrderPositionDetails"
import planningObjectsProductionOrderDetails from "./planningObjectsProductionOrderDetails"
import planningObjectsProjectDetails from "./planningObjectsProjectDetails"
import planningTimelineActivityDetails from "./planningTimelineActivityDetails"
import planningTimelineOrderPositionDetails from "./planningTimelineOrderPositionDetails"
import planningTimelineProjectDetails from "./planningTimelineProjectDetails"
import productionTimelineProductionOrderDetails from "./productionTimelineProductionOrderDetails"
import dashboardRoles from "./dashboardRoles"

export default combineReducers({
  templates,
  templateDetails,
  technologies,
  technologyDetails,
  customers,
  imports,
  resources,
  resourceDetails,
  projectDetails,
  projects,
  orderPositions,
  activityDetails,
  activities,
  holidays,
  productionOrders,
  operations,

  amountUnits,

  basedataResourceDetails,

  planningObjectsActivityDetails,
  planningObjectsOperationDetails,
  planningObjectsOrderPositionDetails,
  planningObjectsProductionOrderDetails,
  planningObjectsProjectDetails,

  planningTimelineProjectDetails,
  planningTimelineOrderPositionDetails,
  planningTimelineActivityDetails,

  productionTimelineProductionOrderDetails,

  licenceModules,
  licenceModuleDetails,
  licenceExistence,

  userList,
  userDetails,

  dashboardRoles,
  modules,
  modulesUserManagement,
})
